import { inject, observer } from 'mobx-react';
import ReactComponent from '../../../ReactComponent';
import { Box } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import RascunhoCertidaoComCarregamento from './RascunhoCertidaoComCarregamento';
import AutoTexto from '@/components/shared/AutoTexto/AutoTexto';
import AUTO_TEXTO_CERTIDAO from '@/components/certidao/AutoTextoCertidao';
import CamposAutoTextoWrapper from '@/components/certidao/CamposAutoTextoWrapper';

class RascunhoPreSessao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            opcoesAutoTexto: computed,
            getQuantidadeObservacoes: action,
            handleIncluirTextoNoRascunho: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get opcoesAutoTexto() {
        return this.preSessaoStore.autoTexto;
    }

    getQuantidadeObservacoes() {
        return this.salaSessaoStore.getQuantidadeObservacoes(this.registro.rascunhoCertidao);
    }

    handleIncluirTextoNoRascunho = (texto, isObservacao = false) => {
        if (this.registro.rascunhoCertidao && this.registro.rascunhoCertidao.indexOf(texto) !== -1) {
            this.mensagemStore.abrirMensagemAlerta('Conteúdo já presente no texto.');
        } else {
            let conteudoAtual = this.registro.rascunhoCertidao ?? '';
            let novoTexto = texto;

            if (isObservacao) {
                conteudoAtual = this.salaSessaoStore.renumerarObservacoes(conteudoAtual);
                novoTexto = 'Observação ' + (this.getQuantidadeObservacoes() + 1) + ': ' + texto + '.\n';
            }

            const quebraDeLinha = conteudoAtual?.trim() !== '' ? '\n' : '';
            const novoConteudo = `${conteudoAtual}${quebraDeLinha}${novoTexto}`;

            this.preSessaoStore.salvarRascunhoCertidao(this.registro, novoConteudo);
        }
    };

    render() {
        const isDesabilitado = this.registro?.certidaoGerada;
        return (
            <>
                <RascunhoCertidaoComCarregamento
                    registro={this.registro}
                    alturaRascunho={this.observableProps.alturaRascunho}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', flex: 1, width: '100%' }}>
                        <AutoTexto
                            opcoes={this.opcoesAutoTexto}
                            onIncluirOpcaoSelecionada={this.handleIncluirTextoNoRascunho}
                            desabilitado={isDesabilitado}
                            estilosWrapper={{ width: '100%' }}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', flex: 1, width: '100%' }}>
                        <CamposAutoTextoWrapper
                            registro={this.registro}
                            callbackAutoComplete={(texto) => this.handleIncluirTextoNoRascunho(texto, true)}
                            estiloGrid={{ gap: 3, gridTemplateColumns: '1fr 1fr' }}
                            listaComponentes={[
                                AUTO_TEXTO_CERTIDAO.REGISTRO_PRESENCA.id,
                                AUTO_TEXTO_CERTIDAO.RESSALVA_ENTENDIMENTO.id,
                                AUTO_TEXTO_CERTIDAO.RESSALVA_FUNDAMENTACAO.id,
                                AUTO_TEXTO_CERTIDAO.REGISTRO_AUSENCIA.id
                            ]}
                        />
                    </Box>
                </Box>
            </>
        );
    }
}

export default inject('stores')(observer(RascunhoPreSessao));
